<template>
  <div>
    <Separator no-margin />
    <div
      class="py-4 flex justify-between"
      :class="{ 'p-6': padded }"
    >
      <div>
        <slot name="left"></slot>
      </div>
      <div>
        <slot name="right"></slot>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Separator from '@/components/separator/Separator.vue'

defineProps({
  padded: {
    type: Boolean,
    default: true
  }
})
</script>

<style></style>
